import { mapTo } from "rxjs/operators";
import { Injectable } from '@angular/core';
import { fromEvent, merge, Observable, of, Subject } from "rxjs";

import { Notification } from '../model/notification.model';
import { NotificationType } from "../model/notification-type.model";

@Injectable()
export class NotificationService {

  private readonly online$: Observable<boolean>;
  private readonly notifications: Subject<Notification>;

  constructor() {
    console.log('NotificationService');
    this.notifications = new Subject<Notification>();
    this.online$ = merge(
        of(navigator.onLine),
        fromEvent(window, 'online').pipe(mapTo(true)),
        fromEvent(window, 'offline').pipe(mapTo(false))
    );
    this.onNetworkStatus();
  }

  onNetworkStatus(): void {
    this.online$.subscribe(value => {
      if (!value) {
        this.sendNotification({
          title: 'Ops, Falha na conexão',
          message: 'Você está offline, verifique!',
          time: 10000,
          type: NotificationType.WARNING
        });
      }
    });
  }

  /**
   * Envia notificacao para o componente de alert
   * @param notification
   */
  sendNotification(notification: Notification): void {
    this.notifications.next(notification);
  }

  /**
   * Obtem as notificacoes
   */
  getNotification(): Observable<Notification> {
    return this.notifications.asObservable();
  }
}
